import React, { useState } from 'react';
import './project.css';

const projects = [
  {
    title: 'Berryfy',
    status: 'Open Source',
    statusClass: 'bg-success',
    icon: 'bx bx-store project__icon',
    summary: 'Open-source e-commerce platform with a .NET 9 backend, Clean Architecture, SQL Server, and a Next.js storefront.',
    date: 'Personal project | Ongoing',
    links: [
      { label: 'Website', href: 'https://berryfy.org' },
      { label: 'Demo', href: 'https://demo.berryfy.org' },
      { label: 'API Docs', href: 'https://api.berryfy.org/scalar/v1' }
    ],
    highlights: [
      'Built a .NET 9 and ASP.NET Core backend with Clean Architecture, Entity Framework Core, and SQL Server.',
      'Developed a Next.js, React, and TypeScript storefront for a modern e-commerce experience.',
      'Implemented authentication, role-based access, carts, simulated payments, orders, inventory, coupons, and administration.',
      'Added Docker Compose deployment and interactive Scalar API documentation.'
    ],
    skills: '.NET 9, ASP.NET Core, Clean Architecture, Entity Framework Core, SQL Server, Next.js, React, TypeScript, Docker'
  }
];

const BerryfyProject = () => {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section className="project section" id="project">
      <div>
        <h2 className="section__title">Projects</h2>
        <span className="section__subtitle">Open-source e-commerce platform</span>

        <div className="project__container container grid">
          {projects.map((project, index) => (
            <div className="project__content" key={project.title}>
              <div className="project__status">
                <span className={`badge ${project.statusClass} text-white`}>{project.status}</span>
              </div>
              <div>
                <i className={project.icon}></i>
                <h3 className="project__title">{project.title}</h3>
                <p className="project__summary">{project.summary}</p>
                <span className="project__button" onClick={() => setActiveProject(index)}>
                  View More
                  <i className="uil uil-arrow-right project__button-icon"></i>
                </span>
              </div>

              <div className={activeProject === index ? 'projects__modal active-modal' : 'projects__modal'}>
                <div className="projects__modal-content">
                  <i className="uil uil-times projects__modal-close" onClick={() => setActiveProject(null)}></i>
                  <h3 className="projects__modal-title">{project.title}</h3>
                  <p className="projects__modal-description">{project.date}</p>
                  <ul className="projects__modal-projects">
                    {project.highlights.map((highlight) => (
                      <li className="projects__modal-service" key={highlight}>
                        <i className="uil uil-check-circle projects__modal-icon"></i>
                        <p className="projects__modal-info">{highlight}</p>
                      </li>
                    ))}
                  </ul>
                  <p className="projects__modal-skills">{project.skills}</p>
                  {project.links.map((link) => (
                    <a className="projects__modal-link" href={link.href} target="_blank" rel="noreferrer" key={link.href}>
                      {link.label}
                      <i className="bx bx-link-external"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BerryfyProject;
